import { Model } from "../../helpers";
import { LANGUAGES } from "./language.model";
import { Translation } from "./translation.model";

export class TranslatableModel extends Model {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [];
    }

    /**
     * @type {string[]}
     */
    static get translatableAttributesWithLanguageAliases() {

        return this.translatableAttributes.reduce((attributes, attribute) => {

            return attributes.concat(
                LANGUAGES.map((language) => this.makeTranslatableAlias(attribute, language)));
        }, []);
    }

    /**
     * @param {string} attribute
     * @returns {boolean}
     */
    static isTranslatable(attribute) {

        return this.translatableAttributes.indexOf(attribute) !== -1;
    }

    /**
     * @param {string} attribute
     * @param {Language} language
     * @returns {string}
     */
    static makeTranslatableAlias(attribute, language) {

        return language.default ? attribute : `${attribute}_${language.code}`;
    }

    /**
     * @param {Object[]|Translation[]} translations
     * @returns {Object.<string, *>}
     */
    translationsToAttributes(translations) {

        return translations.reduce((attributes, translation) => {

            translation = translation instanceof Translation ? translation : new Translation(translation);

            attributes[ this.constructor.makeTranslatableAlias(translation.property,
                                                               translation.language) ] = translation.translation;

            return attributes;
        }, {});
    }

    getAttributeByLang(attribute, language = 'en') {

        language = language || 'en'; //MBP-1438

        return language !== 'en'? this[`${attribute}_${language}`]: this[attribute];
    }
    /**
     * @param {Object.<string, *>} attributes
     */
    fill(attributes = {}) {

        if (Array.isArray(attributes[ 'translations' ])) {

            Object.assign(attributes, this.translationsToAttributes(attributes[ 'translations' ]));
            delete attributes[ 'translations' ];
        }

        super.fill(attributes);
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/models/translatable-model.js